export enum SupplierRegistry {
    EDV = 'EDV',
    DBS = 'DBS',
}
